const VISITOR_ID_STORAGE_KEY = "ecotour:portal:visitor_id";

export function createVisitorId() {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `pv_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getStoredVisitorId() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(VISITOR_ID_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getOrCreateVisitorId() {
  if (typeof window === "undefined") return null;
  try {
    const existing = window.localStorage.getItem(VISITOR_ID_STORAGE_KEY);
    if (existing) return existing;
    const generated = createVisitorId();
    window.localStorage.setItem(VISITOR_ID_STORAGE_KEY, generated);
    return generated;
  } catch {
    return createVisitorId();
  }
}

export { VISITOR_ID_STORAGE_KEY };
